import { render, staticRenderFns } from "./WarningWrapper.vue?vue&type=template&id=1e2bf03e&scoped=true&"
import script from "./WarningWrapper.vue?vue&type=script&lang=js&"
export * from "./WarningWrapper.vue?vue&type=script&lang=js&"
import style0 from "./WarningWrapper.vue?vue&type=style&index=0&id=1e2bf03e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2bf03e",
  null
  
)

export default component.exports